// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  const fullUrl = window.location.pathname + window.location.search;
  const isTargetProduct = window.location.pathname.includes(
    "/products/kiper-reloj-inteligente"
  );

  if (window.__BUNDLE_PICKER_HAMMER__) return;
  window.__BUNDLE_PICKER_HAMMER__ = true;

  const VARIANTS = {
    rosado: "46265101844654",
    azul: "46265101811886",
    negro: "46265101779118",
    vidrio: "46964290486446",
  };

  const DEFAULT_COLOR = "rosado";
  const SWATCH_SEL =
    ".instant-custom-variant-picker[data-instant-option-value]";

  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const norm = (v) => (v || "").toString().trim().toLowerCase();

  const log = (...a) => console.log("%c[BUNDLE PICKER]", "color:#16a34a", ...a);

  const bundleRoot =
    qs("#bundle-block") ||
    qs("[data-bundles-root]") ||
    qs("[data-bundle-root]") ||
    null;

  if (bundleRoot) {
    bundleRoot.setAttribute("data-instant-ignore", "true");
    qsa("[data-instant-action-type]", bundleRoot).forEach((el) =>
      el.removeAttribute("data-instant-action-type")
    );
  }

  function scaleInnerChild(el, scale) {
    const child = el.querySelector(":scope > .instant-custom-variant-picker");
    if (!child) return;
    child.style.transform = scale ? `scale(${scale})` : "";
    child.style.transition = "transform 120ms ease";
  }

  function setActive(el) {
    el.setAttribute("data-bp-active", "true");
    el.style.border = "1.3px solid #18132e";
    el.style.transform = "scale(.9)";
    el.style.transition = "transform 120ms ease, border-color 120ms ease";
    scaleInnerChild(el, 0.85);
  }

  function setInactive(el) {
    el.setAttribute("data-bp-active", "false");
    el.style.border = "";
    el.style.transform = "";
    el.style.transition = "transform 120ms ease, border-color 120ms ease";
    scaleInnerChild(el, null);
  }

  function getSwatchGroups(bundle) {
    const all = qsa(SWATCH_SEL, bundle);
    const top = all.filter((el) => !el.parentElement?.closest(SWATCH_SEL));

    const map = new Map();
    top.forEach((el) => {
      const p = el.parentElement;
      if (!p) return;
      map.set(p, (map.get(p) || 0) + 1);
    });

    const parents = Array.from(map.entries())
      .filter(([, count]) => count >= 2)
      .map(([p]) => p);

    parents.sort((a, b) => {
      const pos = a.compareDocumentPosition(b);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });

    return parents.map((p) => ({
      container: p,
      swatches: top.filter((s) => s.parentElement === p),
    }));
  }

  const bundles = qsa(".custom-picker");

  function activateBundle(bundle) {
    bundles.forEach((b) => {
      b.classList.remove("active");
      qs(".checked-container", b)?.classList.remove("is-checked");
    });
    bundle.classList.add("active");
    qs(".checked-container", bundle)?.classList.add("is-checked");
  }

  bundles.forEach((bundle) => {
    bundle.setAttribute("data-instant-ignore", "true");

    bundle.addEventListener(
      "click",
      (e) => {
        if (e.target.closest("[data-bp-overlay]")) return;
        activateBundle(bundle);
      },
      true
    );
  });

  if (bundles[0]) activateBundle(bundles[0]);

  let syncLock = false;

  function dispatchRealClick(el) {
    if (!el) return;
    el.dispatchEvent(
      new PointerEvent("pointerdown", {
        bubbles: true,
        cancelable: true,
        pointerType: "mouse",
      })
    );
    el.dispatchEvent(
      new MouseEvent("mousedown", { bubbles: true, cancelable: true })
    );
    el.dispatchEvent(
      new PointerEvent("pointerup", {
        bubbles: true,
        cancelable: true,
        pointerType: "mouse",
      })
    );
    el.dispatchEvent(
      new MouseEvent("mouseup", { bubbles: true, cancelable: true })
    );
    el.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true })
    );
  }

  function findPdpSwatchByColor(color) {
    const c = norm(color);
    const all = qsa(SWATCH_SEL).filter((el) => {
      const val = norm(el.getAttribute("data-instant-option-value"));
      const name = norm(el.getAttribute("data-instant-option-name"));
      if (name && name !== "color") return false;
      if (val !== c) return false;
      if (bundleRoot && bundleRoot.contains(el)) return false;
      return true;
    });

    return all[0] || null;
  }

  function syncPdpVariantAndGallery(color) {
    if (syncLock) return;
    const sw = findPdpSwatchByColor(color);
    if (!sw) return;

    syncLock = true;
    try {
      dispatchRealClick(sw);
    } finally {
      setTimeout(() => (syncLock = false), 80);
    }
  }

  function ensureOverlayOnSwatch(swatch, onPick) {
    if (swatch.dataset.bpLocked === "true") return;
    swatch.dataset.bpLocked = "true";

    swatch.style.pointerEvents = "none";
    swatch.style.position = swatch.style.position || "relative";

    const overlay = document.createElement("div");
    overlay.setAttribute("data-bp-overlay", "true");
    overlay.style.position = "absolute";
    overlay.style.inset = "0";
    overlay.style.cursor = "pointer";
    overlay.style.zIndex = "9999";
    overlay.style.background = "transparent";
    overlay.style.pointerEvents = "auto";

    overlay.addEventListener(
      "pointerdown",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();
        onPick?.();
      },
      true
    );

    swatch.appendChild(overlay);
  }

  function buildOverlays() {
    bundles.forEach((bundle) => {
      const groups = getSwatchGroups(bundle);
      if (!groups.length) return;

      groups.forEach((group, index) => {
        const key = index === 0 ? "kiper1" : "kiper2";

        const rosadoSw = group.swatches.find(
          (s) =>
            norm(s.getAttribute("data-instant-option-value")) === DEFAULT_COLOR
        );
        const initial =
          rosadoSw ||
          group.swatches.find(
            (s) => s.getAttribute("data-bp-active") === "true"
          ) ||
          group.swatches.find(
            (s) => s.getAttribute("data-instant-state") === "active"
          ) ||
          group.swatches[0];

        if (initial) {
          group.swatches.forEach(setInactive);
          setActive(initial);

          const c = norm(initial.getAttribute("data-instant-option-value"));
          if (c) bundle.dataset[key] = c;
        }

        group.swatches.forEach((swatch) => {
          const color = norm(swatch.getAttribute("data-instant-option-value"));

          ensureOverlayOnSwatch(swatch, () => {
            group.swatches.forEach(setInactive);
            setActive(swatch);

            if (color) {
              bundle.dataset[key] = color;
              syncPdpVariantAndGallery(color);
              activateBundle(bundle);
            }
          });
        });
      });
    });
  }

  buildOverlays();

  if (bundleRoot) {
    let lock = false;
    const mo = new MutationObserver(() => {
      if (lock) return;
      lock = true;
      setTimeout(() => {
        buildOverlays();
        lock = false;
      }, 60);
    });

    mo.observe(bundleRoot, { childList: true, subtree: true });
  }

  qs(".atc-button")?.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      const bundle = qs(".custom-picker.active");
      if (!bundle) return;

      const c1 = norm(bundle.dataset.kiper1) || DEFAULT_COLOR;
      const c2 = norm(bundle.dataset.kiper2) || c1;

      const items = [];

      if (bundle.classList.contains("first-option")) {
        items.push({ id: VARIANTS[c1], quantity: 1 });
      }

      if (bundle.classList.contains("second-option")) {
        items.push(
          { id: VARIANTS[c1], quantity: 1 },
          { id: VARIANTS.vidrio, quantity: 2 }
        );
      }

      if (bundle.classList.contains("third-option")) {
        items.push(
          { id: VARIANTS[c1], quantity: 1 },
          { id: VARIANTS[c2], quantity: 1 },
          { id: VARIANTS.vidrio, quantity: 4 }
        );
      }

      window.dispatchEvent(
        new CustomEvent("bundle:add", { detail: { items } })
      );
    },
    true
  );

  setTimeout(() => {
    syncPdpVariantAndGallery(DEFAULT_COLOR);

    const activeBundle = qs(".custom-picker.active") || bundles[0];
    if (activeBundle) {
      if (!activeBundle.dataset.kiper1)
        activeBundle.dataset.kiper1 = DEFAULT_COLOR;
      if (!activeBundle.dataset.kiper2)
        activeBundle.dataset.kiper2 = DEFAULT_COLOR;
    }
  }, 350);
});
